import { render, staticRenderFns } from "./navTabs.vue?vue&type=template&id=79641502&"
import script from "./navTabs.vue?vue&type=script&lang=js&"
export * from "./navTabs.vue?vue&type=script&lang=js&"
import style0 from "./navTabs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports